import {
    DiagnosticByDateResponse,
    getDiagnosticByDate,
} from '@yandex-int/k-common/client/api/defs/get-diagnostic-by-date';
import { postDiagnosticAssigned } from '@yandex-int/k-common/client/api/defs/post-diagnostic-assigned';
import { call, put, all, takeLatest } from 'redux-saga/effects';

import { diagnosticsActions } from 'store/diagnostics/actions';

export function* diagnosticsSagasWatcher() {
    yield all([
        takeLatest(diagnosticsActions.getDiagnosticRequest, getDiagnosticSaga),
        takeLatest(diagnosticsActions.postDiagnosticAssignedRequest, postDiagnosticAssignedSaga),
    ]);
}

function* getDiagnosticSaga(action: ReturnType<typeof diagnosticsActions.getDiagnosticRequest>) {
    const { courseId, date, grade, subject, teamId } = action.payload;

    try {
        const diagnostic: DiagnosticByDateResponse = yield call(getDiagnosticByDate, {
            courseId,
            date,
            grade,
            subject,
        });
        // TODO: string vs number
        yield put(diagnosticsActions.getDiagnosticSuccess({ diagnostic: diagnostic as any, subject, teamId }));
    } catch (error) {
        yield put(diagnosticsActions.getDiagnosticError({ subject, teamId }));
        console.error(error);
    }
}

function* postDiagnosticAssignedSaga(action: ReturnType<typeof diagnosticsActions.postDiagnosticAssignedRequest>) {
    const { diagnosticId, courseLessonLinkId, courseId } = action.payload;

    try {
        yield call(postDiagnosticAssigned, { diagnosticId, courseLessonLinkId, courseId });
    } catch (error) {
        console.error(error);
    }
}
